// Sentence-array editor — Pains, Value props, Question guide, Sales rules.
// Renders one textarea per item (longer-form than the chip-based BulletListEditor).

import { useT } from '@barel/i18n';
import { Button, Textarea } from '@barel/ui';

import { useListEditor } from '@/lib/useListEditor';

export interface SentenceListEditorProps {
  values: string[];
  onChange: (next: string[]) => void;
  placeholder: string;
  addLabel: string;
  testId?: string;
}

export function SentenceListEditor({
  values,
  onChange,
  placeholder,
  addLabel,
  testId,
}: SentenceListEditorProps) {
  const tCommon = useT('common');

  const list = useListEditor(values, onChange);

  const update = (idx: number, value: string): void => {
    list.updateAt(idx, () => value);
  };
  const remove = (idx: number): void => {
    list.removeAt(idx);
  };
  const add = (): void => {
    list.add('');
  };

  return (
    <div className="flex w-full flex-col gap-2" data-testid={testId}>
      {values.map((value, idx) => (
        <div
          key={idx}
          className="flex w-full items-start gap-2"
          data-testid={testId ? `${testId}-row-${idx}` : undefined}
        >
          <div className="min-w-0 flex-1">
            <Textarea
              value={value}
              rows={2}
              placeholder={placeholder}
              onChange={(event) => update(idx, event.target.value)}
              data-testid={testId ? `${testId}-input-${idx}` : undefined}
            />
          </div>
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="shrink-0"
            aria-label={tCommon('actions.remove')}
            onClick={() => remove(idx)}
            data-testid={testId ? `${testId}-remove-${idx}` : undefined}
          >
            ×
          </Button>
        </div>
      ))}
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={add}
        data-testid={testId ? `${testId}-add` : undefined}
      >
        {addLabel}
      </Button>
    </div>
  );
}
